import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Save, Eye } from 'lucide-react';
import { CodeEditor } from '../components/CodeEditor';
import { PreviewModal } from '../components/PreviewModal';
import { FormPreview } from '../components/FormPreview';
export function SignupFormEditor() {
  const [activeTab, setActiveTab] = useState<'html' | 'css' | 'js'>('html');
  const [showPreview, setShowPreview] = useState(false);
  const [formData, setFormData] = useState({
    html: `<form id="signup-form" class="signup-form">
  <div class="form-group">
    <label for="email">Email Address</label>
    <input type="email" id="email" name="email" required>
  </div>
  <button type="submit">Subscribe</button>
</form>`,
    css: `.signup-form {
  max-width: 400px;
  margin: 0 auto;
}`,
    js: ''
  });
  return <div className="space-y-6" data-id="element-1747">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-1748">
        <div className="flex items-center gap-4" data-id="element-1749">
          <Link to="/forms" className="p-2 hover:bg-gray-100 rounded-full text-gray-500" data-id="element-1750">
            <ArrowLeft className="h-5 w-5" data-id="element-1751" />
          </Link>
          <div data-id="element-1752">
            <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1753">
              Edit Form: Main Website Newsletter
            </h1>
            <p className="text-sm text-gray-500" data-id="element-1754">
              Configure the raw HTML, CSS, and JS for this form.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3" data-id="element-1755">
          <button onClick={() => setShowPreview(true)} className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50" data-id="element-1756">
            <Eye className="h-4 w-4" data-id="element-1757" />
            Preview
          </button>
          <button className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700" data-id="element-1758">
            <Save className="h-4 w-4" data-id="element-1759" />
            Save Changes
          </button>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-6" data-id="element-1760">
        {/* Main Editor Area */}
        <div className="col-span-2 space-y-6" data-id="element-1761">
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-1762">
            <div className="border-b border-gray-200 px-4 py-3 flex items-center gap-4" data-id="element-1763">
              <button onClick={() => setActiveTab('html')} className={`text-sm font-medium px-3 py-1.5 rounded-md transition-colors ${activeTab === 'html' ? 'bg-blue-50 text-blue-700' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1764">
                HTML
              </button>
              <button onClick={() => setActiveTab('css')} className={`text-sm font-medium px-3 py-1.5 rounded-md transition-colors ${activeTab === 'css' ? 'bg-blue-50 text-blue-700' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1765">
                CSS
              </button>
              <button onClick={() => setActiveTab('js')} className={`text-sm font-medium px-3 py-1.5 rounded-md transition-colors ${activeTab === 'js' ? 'bg-blue-50 text-blue-700' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1766">
                JavaScript
              </button>
            </div>
            <div className="p-4" data-id="element-1767">
              {activeTab === 'html' && <CodeEditor label="Form HTML" language="html" placeholder="<form>...</form>" value={formData.html} onChange={e => setFormData({
              ...formData,
              html: e.target.value
            })} data-id="element-1768" />}
              {activeTab === 'css' && <CodeEditor label="Custom CSS" language="css" placeholder=".signup-form { ... }" value={formData.css} onChange={e => setFormData({
              ...formData,
              css: e.target.value
            })} data-id="element-1769" />}
              {activeTab === 'js' && <CodeEditor label="Custom JavaScript" language="javascript" placeholder="document.querySelector..." value={formData.js} onChange={e => setFormData({
              ...formData,
              js: e.target.value
            })} data-id="element-1770" />}
            </div>
          </div>
        </div>

        {/* Sidebar Settings */}
        <div className="space-y-6" data-id="element-1771">
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 space-y-4" data-id="element-1772">
            <h3 className="text-sm font-medium text-gray-900 border-b border-gray-200 pb-2" data-id="element-1773">
              Settings
            </h3>

            <div className="space-y-2" data-id="element-1774">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1775">
                Form Name
              </label>
              <input type="text" className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" defaultValue="Main Website Newsletter" data-id="element-1776" />
            </div>

            <div className="space-y-2" data-id="element-1777">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1778">
                URL Slug
              </label>
              <div className="flex rounded-md shadow-sm" data-id="element-1779">
                <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm" data-id="element-1780">
                  /forms/
                </span>
                <input type="text" className="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md border-gray-300 focus:ring-blue-500 focus:border-blue-500 sm:text-sm" defaultValue="main-newsletter" data-id="element-1781" />
              </div>
            </div>

            <div className="space-y-2" data-id="element-1782">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1783">
                Allowed Domains
              </label>
              <textarea rows={3} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" placeholder="example.com&#10;staging.example.com" defaultValue="example.com" data-id="element-1784" />
              <p className="text-xs text-gray-500" data-id="element-1785">
                One domain per line. CORS will be restricted to these domains.
              </p>
            </div>

            <div className="space-y-2" data-id="element-1786">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1787">
                Status
              </label>
              <select className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-1788">
                <option value="active" data-id="element-1789">Active</option>
                <option value="draft" data-id="element-1790">Draft</option>
                <option value="archived" data-id="element-1791">Archived</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <PreviewModal isOpen={showPreview} onClose={() => setShowPreview(false)} title="Form Preview" data-id="element-1792">
        <FormPreview html={formData.html} css={formData.css} data-id="element-1793" />
      </PreviewModal>
    </div>;
}